<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    title: {
      type: [String, Number],
      required: true,
    },
    subtitle: {
      type: String,
      required: false,
    },
    marginless: {
      type: Boolean,
      default: false,
      required: false,
    },
    light: {
      type: Boolean,
      default: false,
      required: false,
    },
    size: {
      type: [String, Number],
      default: 'small',
      validator(value) {
        return ['small', 'medium', 'large', 'larger'].includes(value);
      },
      required: false,
    },
    align: {
      type: String,
      default: 'left',
      validator(value) {
        return ['left', 'center'].includes(value);
      },
      required: false,
    },
  });

  const classes = computed(() => ({
    'credere-header': true,
    'variant--marginless': props.marginless,
    'variant--light': props.light,
    [`size--${props.size}`]: true,
    [`align--${props.align}`]: true,
  }));
</script>

<template>
  <section :class="classes">
    <h2 class="credere-header-title">
      {{ title }}
    </h2>

    <h6
      v-if="subtitle"
      class="credere-header-subtitle"
    >
      {{ subtitle }}
    </h6>
  </section>
</template>

<style lang="scss">
  .credere-header {
    --margin: 0 0 var(--token-spacing-giga) 0;

    &.align--center {
      text-align: center;
    }

    &.variant--marginless,
    &:first-child:last-child {
      --margin: 0;
    }
  }

  .credere-header-title {
    --font-size: var(--token-font-size-xxl);
    --font-weight: var(--token-font-weight-bold);
    --line-height: var(--token-line-height-s);

    @container (max-width: 768px) {
      --font-size: var(--token-font-size-xl);
    }

    .size--small & {
      --font-size: var(--token-font-size-xl);

      @container (max-width: 768px) {
        --font-size: var(--token-font-size-l);
      }
    }

    .size--large & {
      --font-size: var(--token-font-size-xxxl);

      @container (max-width: 768px) {
        --font-size: var(--token-font-size-xl);
      }
    }

    .size--larger & {
      --font-size: var(--token-font-size-mega);

      @container (max-width: 768px) {
        --font-size: var(--token-font-size-xxl);
      }
    }

    .variant--light & {
      --color: var(--token-color-constant-light);
    }
  }

  .credere-header-subtitle {
    --color: var(--token-color-neutral-dark);
    --font-size: var(--token-font-size-m);
    --font-weight: var(--token-font-weight-regular);
    --line-height: var(--token-line-height-l);

    @container (max-width: 768px) {
      --font-size: var(--token-font-size-s);
    }

    .size--larger & {
      --font-size: var(--token-font-size-xl);

      @container (max-width: 768px) {
        --font-size: var(--token-font-size-s);
      }
    }

    .variant--light & {
      --color: var(--token-color-constant-light);
    }
  }
</style>
